import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { confirmMailing } from '../services/mailingService';
import usePageMeta from '../hooks/usePageMeta';
import { mailingCardStyle, mailingButtonStyle } from '../components/mailingStyles';

// One request per token: the link is single-use, so a second call (StrictMode
// double effects, a re-render) would 404 after the first one succeeded.
const pending = new Map();
const confirmOnce = (token) => {
  if (!pending.has(token)) pending.set(token, confirmMailing(token));
  return pending.get(token);
};

/** /correos/confirmar?t=… — double opt-in landing page. */
const MailingConfirmPage = () => {
  const { t } = useTranslation('mailing');
  const [params] = useSearchParams();
  const token = params.get('t') || '';
  const [state, setState] = useState({ status: 'loading', subscriber: null });

  usePageMeta({ title: t('confirm.metaTitle') });

  useEffect(() => {
    let cancelled = false;
    if (!token) {
      setState({ status: 'invalid', subscriber: null });
      return undefined;
    }
    (async () => {
      try {
        const { subscriber } = await confirmOnce(token);
        if (!cancelled) setState({ status: 'done', subscriber });
      } catch {
        if (!cancelled) setState({ status: 'invalid', subscriber: null });
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="container" style={{ padding: '2rem 0' }}>
      <div style={mailingCardStyle}>
        {state.status === 'loading' && <p style={{ color: '#666' }}>{t('confirm.confirming')}</p>}
        {state.status === 'invalid' && (
          <>
            <p style={{ color: '#666', marginBottom: '1.5rem' }}>{t('confirm.invalid')}</p>
            <Link to="/" style={mailingButtonStyle}>{t('confirm.backHome')}</Link>
          </>
        )}
        {state.status === 'done' && (
          <>
            <h1 style={{ fontSize: '1.6rem', marginBottom: '0.75rem', fontFamily: "'Gambado Sans', sans-serif" }}>{t('confirm.title')}</h1>
            <p style={{ color: '#555', marginBottom: '1.5rem', lineHeight: 1.5 }}>{t('confirm.text', { email: state.subscriber.email })}</p>
            <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
              <Link to={`/correos/preferencias?t=${encodeURIComponent(state.subscriber.token)}`} style={mailingButtonStyle}>{t('confirm.choose')}</Link>
              <Link to="/" style={{ ...mailingButtonStyle, background: 'none', color: '#1a1a1a' }}>{t('confirm.backHome')}</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MailingConfirmPage;
